import React, { Component } from "react";
import Loader from "./loader";
import TeamOverview from "./TeamOverview";

class TeamDetailsPage extends Component {
  state = {
    teamData: null,
    loading: true,
    error: null,
    title: "",
    section_title: "",
    teacher_section: [],
    siteLanguage: ''
  };

  componentDidMount() {
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const siteLanguage = localStorage.getItem("siteLanguage") || "en";
    this.setState.siteLanguage = siteLanguage
    import("axios").then(({ default: axios }) => {
      axios
        .post(`${BackendUrl}/team-members/multiple/1`)
        .then((response) => {
          const data = response.data.data[0];
          this.setState({
            title: data.title?.[siteLanguage] || data.title?.en,
            section_title: data.section_title?.[siteLanguage] || data.section_title?.en,
            teacher_section: data.teacher_section.map((item) => ({
              image_url: item.image_url,
              name: item.name?.[siteLanguage] || item.name?.en,
              teaching_role: item.teaching_role?.[siteLanguage] || item.teaching_role?.en,
              description: item.description?.[siteLanguage] || item.description?.en,
            })),
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    });
  }

  render() {
     const {teacher_section, loading, error } = this.state;

    if (loading) {
      return <Loader />;
    }

    if (error) {
      return <div>Error: {error}</div>;
    }

    if (!teacher_section || teacher_section.length === 0) {
      return <div>No team data available.</div>;
    }

    return (
      <div className={`container-fluid team py-3 ${this.setState.siteLanguage === 'ur' ? ' direction-rtl' : ''}`}>
        <div className="container">
          <div
            className="text-center mx-auto mb-3"
            style={{ maxWidth: "700px" }}
          >
            <p className="fs-5 text-uppercase text-primary">{this.state.title}</p>
            <h1 className="display-6">{this.state.section_title}</h1>
          </div>

          {/* Main Team Layout */}
          {teacher_section.map((item, index) => (
            <div className="row g-5 my-1">
              <div className="col-lg-4 col-xl-5">
                <div className="team-img ">
                  <img
                    src={item.image_url}
                    className="img-fluid"
                    alt={item.image_url}
                  />
                </div>
              </div>
              <div className="col-lg-8 col-xl-7">
                <div className="team-item ">
                  <h2>{item.name}</h2>
                  <h5 className="fw-normal fst-italic text-primary mb-4">
                    {item.teaching_role}
                  </h5>
                  <p className="mb-4">{item.description}</p>
                  <div className="team-icon d-flex pb-4 mb-4 border-bottom border-primary"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <TeamOverview />
      </div>
    );
  }
}
export default TeamDetailsPage;
